module.exports = {
  adminKey: "admin",
  empKey: "Employees",
  customerKey: "Client",
  subadmin: "subadmin",
  cordinator: "cordinator",
  HoD: "Hod",
};
